/*
 * Solis wrong-country notice (TEL-605). Keep this file: see the Telos repo,
 * docs/modules/cms.md "Wrong-country notice".
 *
 * The UK and EU markets share www.solisprints.co.uk, so the address does not
 * set the country. Shopify takes it from a ?country= / ?currency= link first,
 * then a cookie that lasts a year, then the visitor's connection. A feed link
 * for another country (Google Shopping, ChatGPT) can keep a UK visitor on
 * euros for a year. This bar offers the switch when Shopify's own lookup of
 * the connection names a country we sell to that differs from the page's.
 *
 * It never shows: to crawlers, after the visitor picked a country or language
 * in the theme menu (1 year), for 30 days after a close, or when the
 * connection's country is not in the menu.
 */
(function () {
  'use strict';

  var KEY_DISMISSED = 'solis.countryHint.dismissedUntil';
  var KEY_CHOSEN = 'solis.countryHint.chosenUntil';
  var KEY_DETECTED = 'solis.countryHint.detected';
  var DAY = 86400000;
  var BOT_UA = /bot|crawler|spider|slurp|mediapartners|lighthouse|pagespeed|facebookexternalhit|embedly|preview/i;
  var NEEDS_THE = { GB: 1, US: 1, NL: 1 };

  var TEXT = {
    en: { ask: function (n, code) { return 'Shopping from ' + (NEEDS_THE[code] ? 'the ' : '') + '<strong>' + n + '</strong>?'; },
          show: 'Show prices in {c}', close: 'Close', region: 'Country suggestion' },
    de: { ask: function (n) { return 'Standort: <strong>' + n + '</strong>'; }, show: 'Preise in {c} anzeigen', close: 'Schließen', region: 'Ländervorschlag' },
    sv: { ask: function (n) { return 'Plats: <strong>' + n + '</strong>'; }, show: 'Visa priser i {c}', close: 'Stäng', region: 'Förslag på land' },
    nl: { ask: function (n) { return 'Locatie: <strong>' + n + '</strong>'; }, show: 'Prijzen in {c} tonen', close: 'Sluiten', region: 'Landsuggestie' },
    fr: { ask: function (n) { return 'Localisation : <strong>' + n + '</strong>'; }, show: 'Afficher les prix en {c}', close: 'Fermer', region: 'Suggestion de pays' },
    it: { ask: function (n) { return 'Posizione: <strong>' + n + '</strong>'; }, show: 'Mostra i prezzi in {c}', close: 'Chiudi', region: 'Paese suggerito' },
    es: { ask: function (n) { return 'Ubicación: <strong>' + n + '</strong>'; }, show: 'Ver precios en {c}', close: 'Cerrar', region: 'País sugerido' }
  };

  function store(kind) {
    try { return window[kind]; } catch (e) { return null; }
  }
  function read(kind, key) {
    var s = store(kind);
    try { return s ? s.getItem(key) : null; } catch (e) { return null; }
  }
  function write(kind, key, value) {
    var s = store(kind);
    try { if (s) s.setItem(key, value); } catch (e) { /* private mode: ignore */ }
  }
  function stillActive(key) {
    var until = Number(read('localStorage', key));
    return until && until > Date.now();
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  // A choice in the theme's own country or language menu counts as deliberate.
  document.addEventListener('click', function (event) {
    var t = event.target;
    if (t && t.closest && t.closest('.localization-form__list-item')) {
      write('localStorage', KEY_CHOSEN, String(Date.now() + 365 * DAY));
    }
  }, true);
  document.addEventListener('change', function (event) {
    var t = event.target;
    if (t && t.name === 'language_code' && t.closest && t.closest('form[action$="/localization"]') && !t.closest('#solis-country-hint')) {
      write('localStorage', KEY_CHOSEN, String(Date.now() + 365 * DAY));
    }
  }, true);

  // The theme keeps its country menu inside <template> elements until opened.
  function findAll(selector) {
    var live = document.querySelectorAll(selector);
    if (live.length) return live;
    var templates = document.querySelectorAll('template');
    for (var i = 0; i < templates.length; i++) {
      var found = templates[i].content && templates[i].content.querySelectorAll(selector);
      if (found && found.length) return found;
    }
    return [];
  }

  function sellable() {
    var out = {};
    var items = findAll('.localization-form__list-item[data-value]');
    for (var i = 0; i < items.length; i++) {
      var code = items[i].getAttribute('data-value');
      if (out[code]) continue;
      var nameEl = items[i].querySelector('.country');
      var curEl = items[i].querySelector('.localization-form__currency');
      out[code] = {
        name: (nameEl ? nameEl.textContent : items[i].getAttribute('aria-label') || code).trim(),
        currency: (curEl ? curEl.textContent : '').trim()
      };
    }
    return out;
  }

  function currencyLabel(text) {
    // "GBP £" -> "£", "EUR €" -> "€", "USD $" -> "USD", "SEK kr" -> "SEK".
    var parts = text.split(/\s+/);
    var symbol = parts[parts.length - 1];
    return symbol === '£' || symbol === '€' ? symbol : parts[0];
  }

  function detect() {
    var cached = read('sessionStorage', KEY_DETECTED);
    if (cached) return Promise.resolve(cached === '-' ? null : cached);
    return fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var c = data && data.detected_values && data.detected_values.country;
        var handle = c && c.handle ? String(c.handle).toUpperCase() : null;
        write('sessionStorage', KEY_DETECTED, handle || '-');
        return handle;
      })
      .catch(function () { return null; });
  }

  function switchTo(code) {
    var themeForm = findAll('form[action$="/localization"]')[0];
    var returnInput = themeForm && themeForm.querySelector('input[name="return_to"]');
    var url = new URL(returnInput ? returnInput.value : location.pathname + location.search, location.origin);
    url.searchParams.delete('country');
    url.searchParams.delete('currency');
    var lang = themeForm && themeForm.querySelector('[name="language_code"]');
    var fields = {
      form_type: 'localization',
      utf8: '✓',
      _method: 'put',
      return_to: url.pathname + url.search + url.hash,
      country_code: code,
      language_code: lang && lang.value ? lang.value : (window.Shopify && Shopify.locale) || 'en'
    };
    var form = document.createElement('form');
    form.method = 'post';
    form.action = (themeForm && themeForm.getAttribute('action')) || '/localization';
    form.style.display = 'none';
    Object.keys(fields).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }

  function render(code, info) {
    var lang = String((window.Shopify && Shopify.locale) || document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    var t = TEXT[lang] || TEXT.en;
    if (!document.getElementById('solis-country-hint-style')) {
      var style = document.createElement('style');
      style.id = 'solis-country-hint-style';
      style.textContent =
        '#solis-country-hint{display:flex;align-items:center;gap:12px;padding:10px 12px 10px 16px;background:#fff;color:#1c1b19;' +
        'border-bottom:1px solid rgba(28,27,25,.14);font-family:inherit;font-size:14px;line-height:1.35;position:relative}' +
        '#solis-country-hint p{margin:0;flex:1 1 auto;min-width:0}' +
        '#solis-country-hint .solis-country-hint__switch{background:#1c1b19;color:#fff;border:0;border-radius:999px;padding:9px 15px;' +
        'font:inherit;font-size:13px;font-weight:500;white-space:nowrap;cursor:pointer}' +
        '#solis-country-hint .solis-country-hint__close{background:none;border:0;color:#5c5a55;font-size:22px;line-height:1;padding:4px 6px;cursor:pointer}' +
        '#solis-country-hint button:focus-visible{outline:2px solid #1c1b19;outline-offset:2px}' +
        '@media (min-width:990px){#solis-country-hint{justify-content:center;gap:20px;padding:10px 24px}#solis-country-hint p{flex:0 1 auto}}';
      document.head.appendChild(style);
    }
    var bar = document.createElement('div');
    bar.id = 'solis-country-hint';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', t.region);
    bar.setAttribute('data-nosnippet', '');
    bar.innerHTML =
      '<p>' + t.ask(escapeHtml(info.name), code) + '</p>' +
      '<button type="button" class="solis-country-hint__switch">' + escapeHtml(t.show.replace('{c}', currencyLabel(info.currency))) + '</button>' +
      '<button type="button" class="solis-country-hint__close" aria-label="' + escapeHtml(t.close) + '">&times;</button>';
    bar.querySelector('.solis-country-hint__switch').addEventListener('click', function () { switchTo(code); });
    bar.querySelector('.solis-country-hint__close').addEventListener('click', function () {
      write('localStorage', KEY_DISMISSED, String(Date.now() + 30 * DAY));
      bar.parentNode.removeChild(bar);
    });
    var anchor = document.querySelector('.shopify-section-group-header-group');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(bar, anchor);
    else document.body.insertBefore(bar, document.body.firstChild);
  }

  function run() {
    if (BOT_UA.test(navigator.userAgent || '')) return;
    if (!window.Shopify || !Shopify.country || !window.fetch || !window.URL) return;
    if (stillActive(KEY_DISMISSED) || stillActive(KEY_CHOSEN)) return;
    var current = String(Shopify.country).toUpperCase();
    var list = sellable();
    detect().then(function (code) {
      if (!code || code === current || !list[code] || !list[code].currency) return;
      if (document.getElementById('solis-country-hint')) return;
      render(code, list[code]);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
